









import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import LoadingIndicator from '@components/LoadingIndicator'

settings = 
  name: 'WaitingModal'

  vue:
    props: ['show']

    components: {
      Modal,
      LoadingIndicator,
    }

export default VueOptions.vue settings
